// extracted by mini-css-extract-plugin
module.exports = {"root":"RedirectBanner_root__kO_2o","completionText":"RedirectBanner_completionText__gDhtM"};